let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fYgDU")).then(() => parcelRequire('djL4Z'));